var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-list" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("redeems")) + "\n    ")
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "request_redeem",
              label: _vm.$t("request_redeem")
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "sales_history",
              label: _vm.$t("sales_history")
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "photo_upload_history",
              label: _vm.$t("photo_upload_history")
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "redeem_history",
              label: _vm.$t("redeem_history")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { attrs: { name: "request_redeem" } },
            [_c("request-redeem")],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "sales_history" } },
            [_c("sales-history")],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "photo_upload_history", "keep-alive": "" } },
            [_c("photo-upload-history")],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "redeem_history" } },
            [_c("redeem-history")],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "reward_orders" })
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }